import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
export function HeroSectionBookACall() {
  useEffect(() => {
    // Load Wistia player script
    const script1 = document.createElement('script');
    script1.src = 'https://fast.wistia.com/player.js';
    script1.async = true;
    document.body.appendChild(script1);
    const script2 = document.createElement('script');
    script2.src = 'https://fast.wistia.com/embed/dmary3z10e.js';
    script2.async = true;
    script2.type = 'module';
    document.body.appendChild(script2);
    return () => {
      if (document.body.contains(script1)) {
        document.body.removeChild(script1);
      }
      if (document.body.contains(script2)) {
        document.body.removeChild(script2);
      }
    };
  }, []);
  return <section className="relative pt-20 pb-10 md:pt-28 lg:pt-36 md:pb-14 lg:pb-20 overflow-hidden bg-gradient-to-b from-gray-900 to-black" data-id="element-353">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-354">
        <div className="text-center mb-6 md:mb-10" data-id="element-355">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="text-2xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-3 md:mb-5 px-2" data-id="element-356">
            Descubre cómo la IA puede{' '}
            <span className="text-[#7FFF00]" data-id="element-357">transformar tu negocio</span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-sm md:text-base lg:text-lg text-gray-100 max-w-3xl mx-auto leading-relaxed px-2" data-id="element-358">
            Mira este video para entender cómo nuestro sistema de inteligencia
            artificial puede ayudarte a crear, lanzar y escalar productos
            digitales de forma más rápida y efectiva que nunca.
          </motion.p>
        </div>

        {/* Video Container */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="relative max-w-4xl mx-auto" data-id="element-359">
          {/* Video wrapper with border glow effect */}
          <div className="relative bg-black shadow-2xl overflow-hidden aspect-video border border-[#7FFF00]/30" style={{
          boxShadow: '0 0 0 1px rgba(127, 255, 0, 0.3), 0 0 20px rgba(127, 255, 0, 0.4), 0 0 40px rgba(127, 255, 0, 0.3), 0 0 60px rgba(127, 255, 0, 0.2)'
        }} data-id="element-360">
            {/* Wistia Player */}
            <style dangerouslySetInnerHTML={{
            __html: `
                wistia-player[media-id='dmary3z10e']:not(:defined) { 
                  background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/dmary3z10e/swatch'); 
                  display: block; 
                  filter: blur(5px); 
                  padding-top: 56.25%; 
                }
              `
          }} data-id="element-361" />
            <wistia-player media-id="dmary3z10e" aspect="1.7777777777777777" className="w-full h-full" data-id="element-362" />
          </div>

          {/* Video Context */}
          <div className="mt-5 md:mt-7 bg-gray-900 rounded-lg md:rounded-xl p-4 md:p-5 border border-gray-800" data-id="element-363">
            <h3 className="font-semibold text-white mb-2 md:mb-3 text-sm md:text-base" data-id="element-364">
              En el video descubrirás:
            </h3>
            <ul className="grid md:grid-cols-3 gap-3 md:gap-4 text-xs md:text-sm text-gray-100" data-id="element-365">
              <li className="flex items-start" data-id="element-366">
                <span className="w-1.5 h-1.5 bg-[#7FFF00] rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-367" />
                Cómo funciona nuestro sistema de IA para crear productos
                digitales.
              </li>
              <li className="flex items-start" data-id="element-368">
                <span className="w-1.5 h-1.5 bg-[#7FFF00] rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-369" />
                Los resultados que están obteniendo nuestros clientes.
              </li>
              <li className="flex items-start" data-id="element-370">
                <span className="w-1.5 h-1.5 bg-[#7FFF00] rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-371" />
                Por qué este es el momento perfecto para empezar.
              </li>
            </ul>
            <div className="mt-4 md:mt-5 pt-4 md:pt-5 border-t border-gray-800 text-center" data-id="element-372">
              <p className="text-white font-medium flex flex-col md:flex-row items-center justify-center text-xs md:text-sm gap-1 md:gap-0" data-id="element-373">
                <span data-id="element-374">
                  Después del video, agenda tu llamada para recibir un plan
                  personalizado.
                </span>
                <ArrowDown className="w-4 h-4 md:ml-2 animate-bounce text-[#7FFF00]" data-id="element-375" />
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}